<template>
  <div class="student_box student_bg">
    <header class="flex-align-between student-head">
      <img class="student-logo" src="@/assets/student/student-logo.png">
      <div class="flex-align-center back-box" @click="goBack">
        <img alt="" class="back-ico" src="@/assets/student/back-ico.png">
        <span class="back-text">返回</span>
      </div>
    </header>
    <div class="flex-align-center">
      <div class="student-class-name flex-align-between">
        <div class="dot"></div>
        <div>提交作品</div>
        <div class="dot"></div>
      </div>
    </div>
    <div class="flex-align-center upload-box ">
      <el-upload v-if="fileList.length == 0" action="" :multiple="false" :show-file-list="false"
        :http-request="httpRequest">
        <div class="flex-column-center upload-send">
          <img alt="" class="upload-1" src="@/assets/student/upload-1.png">
          <div class="flex-align-center">
            <span class="text">上传图片</span>
            <img alt="" class="upload-2" src="@/assets/student/upload-2.png">
          </div>
        </div>
      </el-upload>
      <template v-else>
        <div class="flex-column-center upload-show" v-for="(item, index) in fileList" :key="index" v-loading="loading"
          element-loading-text="识别中...">
          <img alt="" class="upload-close" src="@/assets/student/upload-close.png" @click="delUpliad">
          <div>
            <img alt="" class="upload-file" :src="item">
          </div>
        </div>
      </template>
    </div>
    <!-- 确定按钮 -->
    <div class="confirm-section">
      <button class="confirm-btn" :disabled="isSubmit" @click="submitUpload">
        提交作品
      </button>
    </div>
  </div>
</template>
<script>
const OSS = require('ali-oss');

export default {
  components: {},
  name: "SubmitWork",
  data() {
    return {
      numPages: null,
      selectedStudent: null,
      isSubmit: true,
      fileList: [],
      uploadId: null,
      intervalId: null,
      failStatus: null,
      failList: {
        2: "oss文件下载错误",
        3: '二维码未找到',
        4: "识别发生异常",
        5: "没有匹配到字",
        6: '空白的字格',
        7: "字形模板文件不存在",
        8: "作品图不完整或不清晰",
        9: "条形码未识别",
        10: "非本次测评卷"
      },
      loading: false,
    };
  },
  mounted() {
    this.initOss()
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async initOss() {
      let resData = await this.$Api.Upload.getQueryToken();
      // console.log('获取ossTpken:', resData);
      this.client = new OSS({
        region: 'oss-cn-beijing',
        authorizationV4: true,
        accessKeyId: resData.data.accessKeyId, // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
        accessKeySecret: resData.data.accessKeySecret,
        stsToken: resData.data.stsToken,// 从STS服务获取的安全令牌（SecurityToken）。
        bucket: resData.data.bucket,// 填写Bucket名称，例如examplebucket。
        timeout: 60000 * 60 * 24
      })
    },
    httpRequest(data) {
      // console.log('自定义上传方法:', data);
      const localUrl = URL.createObjectURL(data.file);
      this.fileList.push(localUrl);
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1;
      const day = currentDate.getDate();
      const timestamp = currentDate.getTime() + '_' + Math.floor(Math.random() * 10000) + 1;
      let name = `static/import/upload/${year}/${month}/${day}/sync-pad-identify-upload-${timestamp}.${data.file.type.split("/")[1]}`
      this.client.put(name, data.file)
        .then(res => {
          // console.log('上传成功:', res);
          this.loading = true;
          this.uploadStuWork(name);
        })
        .catch(err => {
          console.log('上传失败:', err)
        })
    },
    // 上传作品
    async uploadStuWork(filePath) {
      let data = {
        studentId: this.$route.query.studentId,
        testId: this.$route.query.testId,
        classId: this.$route.query.classId,
        filePath,
        teacherId: this.$route.query.teacherId
      }
      let resData = await this.$Api.StuTest.uploadStuWork(data);
      console.log('上传作品结果:', resData);
      this.uploadId = resData.data;
      this.queryWork();
    },
    // 删除作品
    delUpliad() {
      this.fileList = [];
      if (this.intervalId) {
        console.log('清除定时器');
        this.isSubmit = true;
        this.loading = false;
        clearInterval(this.intervalId);
      }
    },
    // 查询作品状态
    queryWork() {
      let data = {
        uploadId: this.uploadId
      }
      this.intervalId = setInterval(async () => {
        let resData = await this.$Api.StuTest.queryWork(data);
        console.log('查询作品状态:', resData);
        if (resData.data.status == 0) {
          clearInterval(this.intervalId);
          this.queryWork()
          return
        }
        if (resData.data.status == 1) {
          this.loading = false;
          this.isSubmit = false;
          clearInterval(this.intervalId);
        } else {
          this.failStatus = resData.data.status;
          this.$message.error(this.failList[resData.data.status]);
          clearInterval(this.intervalId);
        }
      }, 5000);

    },
    // 提交作品
    async submitUpload() {
      if (this.fileList.length == 0) {
        this.$message.error('请先上传作品');
        return
      }
      let data = {
        uploadId: this.uploadId,
        testId: this.$route.query.testId,
        studentId: this.$route.query.studentId,
      }
      let resData = await this.$Api.StuTest.addWork(data);
      console.log('提交作品结果:', resData);
      this.$message({
        message: '提交成功',
        type: 'success'
      });
      setTimeout(() => {
        this.$router.push({
          path: '/student/listWork',
          query: {
            testId: this.$route.query.testId,
            studentId: this.$route.query.studentId
          }
        });
      }, 1000);
    }
  },
  beforeDestroy() {
    if (this.intervalId) {
      console.log('清除定时器');
      clearInterval(this.intervalId);
    }
  }
};
</script>

<style lang="less" scoped>
@import "student.less";
</style>
<style></style>
